module.exports = __webpack_public_path__ + "img/residential_tipo.42eac930.svg";